import BarCharts from "../ComplaintCharts/VerticalBarChart";
import { axInst } from "../../../Components/Login/Service";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";

const origin_point_count = async (body) => {
  try {
    const res = await axInst.post("complaints/origin_point_count", body);
    const data = res.data.Total_Count_Origin;

    const keyData = data.map((item) => item.key);
    const valData = data.map((item) => item.SR_NO_COUNT);

    return { keyData, valData };
  } catch (error) {
    console.error(error);
  }
};

export const OriginPoint = () => {
  const { data, submitted } = useSelector((e) => e.filtersComplaint);
  const {
    data: regwiseret,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["originpoint", submitted],
    queryFn: () => origin_point_count(data),
    initialData: { keyData: [], valData: [] },
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });

  return (
    <div className="p-2 relative">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && (
        <BarCharts
          line={false}
          color={"#FF7200"}
          xaxisdata={regwiseret.keyData}
          yaxisdata={regwiseret.valData}
          heading={"Origin Point"}
          headingColor={"#4f4f4f"}
          headingFont={"16"}
        />
      )}
    </div>
  );
};
